module.exports = __webpack_public_path__ + "img/icon-36.ef638fb1.svg";